/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { usePlayerTranslation } from "../../../../../../shared/context/PlayerTranslationContext";
import {
  DropdownHeader,
  DropdownMenuItem,
  DropdownMenuSection,
  DropdownScrollableArea,
} from "../../../../Base";

import { useSubtitleSettings } from "./useSubtitleSettings";

export const SubtitleSection = () => {
  const { tracks, activeTrack, onTrackSelect } = useSubtitleSettings();
  const { t } = usePlayerTranslation();

  return (
    <DropdownMenuSection name="subtitles">
      <DropdownHeader navigateToSection="settings">
        {t("PLAYER_SETTINGS_SUBTITLES")}
      </DropdownHeader>
      <DropdownScrollableArea>
        {tracks.map((track) => {
          return (
            <DropdownMenuItem
              key={track.id}
              onItemSelect={() => onTrackSelect(track)}
              active={activeTrack.id === track.id}
              resetToDefaultSectionAfterSelect
              showActiveIcon
            >
              {track.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownScrollableArea>
    </DropdownMenuSection>
  );
};
